import { render, staticRenderFns } from "./BillTemplate.vue?vue&type=template&id=93fc189a&scoped=true"
import script from "./BillTemplate.vue?vue&type=script&lang=js"
export * from "./BillTemplate.vue?vue&type=script&lang=js"
import style0 from "./BillTemplate.vue?vue&type=style&index=0&id=93fc189a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fc189a",
  null
  
)

export default component.exports